import {
    FETCH_COMPLAIN,
    FETCH_COMPLAIN_SUCCESS,
    FETCH_COMPLAIN_FAILED,
    EDIT_COMPLAIN
  } from "../store/types";
  import { firebase } from '../config/configureFirebase';
  import store from '../store/store';
  import { get, push, set } from "firebase/database";
  import { sendComplaintNotification } from '../utils/discordNotifications';
  
  // fromTs (epoch ms) is opt-in — caller controls the date floor. Web
  // admin pages pass a 30-day floor to bound payload; mobile customer/
  // driver call sites pass undefined to preserve their original behavior
  // of fetching the full /complain collection (their UI typically filters
  // to the user's own complaints client-side).
  export const fetchComplain = (fromTs) => async (dispatch) => {

    const {
        complainByDateRef
    } = firebase;

    dispatch({
      type: FETCH_COMPLAIN,
      payload: null,
    });
    try {
      const snapshot = await get(complainByDateRef(fromTs));
      if (snapshot.val()) {
        let data = snapshot.val();


        const arr = Object.keys(data).map(i => {
          data[i].id = i;
          return data[i]
        });
        dispatch({
          type: FETCH_COMPLAIN_SUCCESS,
          payload: arr.reverse()
        });
      } else {
        dispatch({
          type: FETCH_COMPLAIN_FAILED,
          payload: store.getState().languagedata.defaultLanguage.no_complain,
        });
      }
    } catch (error) {
      dispatch({
        type: FETCH_COMPLAIN_FAILED,
        payload: error.message,
      });
    }
  };
  
  export const editComplain = (reasons, method) => async (dispatch) => {

    const {
        complainRef,
        editComplainRef
    } = firebase;
  
    dispatch({
      type: EDIT_COMPLAIN,
      payload: {method, reasons}
    });
    
    if (method === 'Add') {
      push(complainRef, reasons);
      
      // Send Discord notification for new complaint
      try {
        const settings = store.getState()?.settingsdata?.settings || {};
        await sendComplaintNotification(reasons, settings);
      } catch (error) {
        console.error('Failed to send Discord complaint notification:', error);
      }
    }
    else if(method === 'Update'){
      // Include all fields from the reasons object including processedBy and comments
      const updateData = {
        ...reasons,
        check: reasons.check !== undefined ? reasons.check : true,
        processDate: reasons.processDate || new Date().getTime(),
        processedBy: reasons.processedBy || '',
        comments: reasons.comments || ''
      };
      set(editComplainRef(reasons.id), updateData);
    }
  }
  
  